/**
 * @param {import("../../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/payments/ancv-connect/transactions",
    },
    (router) => {
      router.push({
        id: "@api/payment.ancv-connect.transaction@create",
        path: "",
      });

      router.group(
        {
          path: "/:paymentAncvConnectTransactionId",
        },
        (router) => {
          router.push({
            id: "@api/payment.ancv-connect.transaction@show",
            path: "",
          });
        },
      );
    },
  );
}
